import { lazy } from 'react';

import IRoute from 'Shared/Routes/Models/IRoute';

import { AtashsooziOmumiPaths } from './AtashsooziOmumiPaths';

const AtashsooziOmumiBimehNamehDetailPage = lazy(() => import('../Detail/AtashsooziOmumiBimehNamehDetailPage'));
const ElhaghiyehHayeSaderehPage = lazy(() => import('../ElhaghiyehHayeSadereh/ElhaghiyehHayeSaderehAtashsooziPage'));
const ElhaghiyehSaderehDetailPage = lazy(() => import('../ElhaghiyehSaderehDetail/ElhaghiyehSaderehDetailPage'));
const AtashsooziEstelamAndSodoorPage = lazy(() => import('../EstelamAndSodoor/AtashsooziEstelamAndSodoorPage'));

export const AtashsooziOmumiRoutes: IRoute[][] = [
  [
    {
      path: AtashsooziOmumiPaths.BimehNameh.EstelamAndSodoor,
      component: AtashsooziEstelamAndSodoorPage,
      needAuth: true,
    },
    {
      path: AtashsooziOmumiPaths.BimehNameh.Detail,
      component: AtashsooziOmumiBimehNamehDetailPage,
      needAuth: true,
    },
    {
      path: AtashsooziOmumiPaths.BimehNameh.ElhaghiyehHayeSadereh,
      component: ElhaghiyehHayeSaderehPage,
      needAuth: true,
    },
    {
      path: AtashsooziOmumiPaths.BimehNameh.ElhaghiyehSaderehDetail,
      component: ElhaghiyehSaderehDetailPage,
      needAuth: true,
      parameters: ['gharardadBimehId'],
    },
  ],
];
